import React from 'react'

function About() {
    return (
        <div>
            {/* Hero Start */}
            <div className="container-fluid pt-5 bg-primary hero-header">
                <div className="container pt-5">
                    <div className="row g-5 pt-5">
                        <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
                            <h1 className="display-4 text-white mb-4 animated slideInRight">About Us</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                                    <li className="breadcrumb-item"><a className="text-white" href="#">Home</a></li>
                                    <li className="breadcrumb-item text-white active" aria-current="page">About Us</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 align-self-end text-center text-lg-end">
                            <img className="img-fluid" src="assets/img/hero-img.png" alt style={{ maxHeight: 300 }} />
                        </div>
                    </div>
                </div>
            </div>
            {/* Hero End */}
            {/* About Start */}
            <div className="container-fluid py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                            <div className="about-img">
                                <img className="img-fluid" src="assets/img/about.png" />
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                            <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">About Us</div>
                            <h1 className="mb-4">We Transform Businesses with Intelligent Technology</h1>
                            <p className="mb-4">
                                Bluevipers Technology is a leading digital solutions and AI innovation company.
                                We help businesses grow smarter by integrating automation, modern software,
                                and strategic brand development. Our mission is to empower organizations with
                                technology that improves efficiency, reduces workload, and builds meaningful
                                digital experiences.
                            </p>
                            <p className="mb-4">
                                With a team of passionate developers, designers, and business strategists,
                                we deliver end-to-end solutions — from custom software development to websites,
                                AI chatbots, ERP systems, mobile apps, and digital marketing.
                                We focus on quality, performance, and long-term growth.
                            </p>

                            <div className="row g-3">
                                <div className="col-sm-6">
                                    <h6 className="mb-3"><i className="fa fa-check text-primary me-2" />Experienced Team</h6>
                                    <h6 className="mb-0"><i className="fa fa-check text-primary me-2" />Quality Driven Approach</h6>
                                </div>
                                <div className="col-sm-6">
                                    <h6 className="mb-3"><i className="fa fa-check text-primary me-2" />24/7 Client Support</h6>
                                    <h6 className="mb-0"><i className="fa fa-check text-primary me-2" />Affordable Pricing</h6>
                                </div>
                            </div>

                            <div className="d-flex align-items-center mt-4">
                                <a className="btn btn-primary rounded-pill px-4 me-3" href="#">Read More</a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-twitter" /></a>
                                <a className="btn btn-outline-primary btn-square me-3" href="#"><i className="fab fa-instagram" /></a>
                                <a className="btn btn-outline-primary btn-square" href="#"><i className="fab fa-linkedin-in" /></a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}
            {/* Feature Start */}
             {/* Feature Start */}
            <div className="container-fluid bg-primary feature pt-5">
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-lg-6 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
                            <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Us</div>
                            <h1 className="text-white mb-4">We Build Reliable & High-Quality Digital Solutions</h1>
                            <p className="text-light mb-4">
                                At Bluevipers Technology, we focus on delivering meaningful digital transformation.
                                Our experienced team ensures that every website, software and mobile app is built
                                with performance, security, and user experience in mind.
                            </p>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Custom Solutions Designed for Your Business Needs</span>
                            </div>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Professional Team with Industry-Level Expertise</span>
                            </div>

                            <div className="d-flex align-items-center text-white mb-3">
                                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                                    <i className="fa fa-check" />
                                </div>
                                <span>Fast Support, On-Time Delivery & Transparent Pricing</span>
                            </div>

                            <div className="row g-4 pt-3">
                                <div className="col-sm-6">
                                    <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                                        <i className="fa fa-users fa-3x text-white" />
                                        <div className="ms-3">
                                            <h2 className="text-white mb-0" data-toggle="counter-up">100+</h2>
                                            <p className="text-white mb-0">Happy Clients</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                                        <i className="fa fa-check fa-3x text-white" />
                                        <div className="ms-3">
                                            <h2 className="text-white mb-0" data-toggle="counter-up">65+</h2>
                                            <p className="text-white mb-0">Projects Delivered</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 align-self-end text-center text-md-end wow fadeIn" data-wow-delay="0.5s">
                            <img className="img-fluid" src="assets/img/feature.png" alt="Bluevipers Technology" />
                        </div>
                    </div>
                </div>
            </div>
            {/* Feature End */}
            {/* Feature End */}
           
           
        </div>

    )
}

export default About